import React from 'react'

const CreditInitialPage = ({ handleClick }) => (
  <div>
    <div className='credit_header'>
      <div className='credit_text'>Nome do Interessado</div>
      <div className='credit_text'>CPF: 000.000.000-00</div>
    </div>

    <div className='credit'>
      <div className='credit_status'>
        <input className='credit_status_input' type='text' />
        <div className='credit_status_text'>Pendências Financeiras</div>
      </div>
      <div className='credit_status'>
        <input className='credit_status_input' type='text' />
        <div className='credit_status_text'>Pendências Comerciais</div>
      </div>
      <div className='credit_status'>
        <input className='credit_status_input' type='text' />
        <div className='credit_status_text'>Protestos</div>
      </div>
      <div className='credit_status'>
        <input className='credit_status_input' type='text' />
        <div className='credit_status_text'>
          Cheques
          <br />
          (Sem fundos)
        </div>
      </div>
    </div>

    <div className='credit_type_wrapper'>
      <div className='credit_type'>
        <div className='credit_type_name'>Score</div>
        <div className='credit_type_value'>
          <div className='credit_type_status'>
            <input className='credit_status_input' type='text' />
          </div>
        </div>
      </div>
      <div className='credit_type_divisor' />
      <div className='credit_type'>
        <div className='credit_type_name'>Classe Score 12 meses</div>
        <div className='credit_type_value'>
          <div className='credit_type_status'>
            <input className='credit_status_input' type='text' />
          </div>
        </div>
      </div>
      <div className='credit_type_divisor' />
      <div className='credit_type'>
        <div className='credit_type_name'>Possibilidade de inadiplência</div>
        <div className='credit_type_value'>
          <div className='credit_type_status'>
            <input className='credit_status_input' type='text' />
          </div>
        </div>
      </div>
      <div className='credit_type_divisor' />
      <div className='credit_type'>
        <div className='credit_type_name'>Situação do CPF</div>
        <div className='credit_type_value'>
          <div className='credit_type_status'>
            <input className='credit_status_input' type='text' />
          </div>
        </div>
      </div>
      <div className='credit_type_divisor' />
    </div>

    <div className='credit_accept'>
      <div className='credit_accept_header'>Obtenha a conferência</div>
      <div className='credit_accept_subtitle'>Para conferir os dados de crédito de</div>
      <div className='credit_accept_subtitle'>seu futuro morador!</div>

      <button className='credit_accept_button' onClick={handleClick}>
        Comprar conferência por R$25
      </button>
    </div>
  </div>
)

// TODO: use ts
// CreditInitialPage.propTypes = {
//   handleClick: PropTypes.func.isRequired,
// }

export default CreditInitialPage
